var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemini({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2803 2.85938C11.3357 5.78782 13.6419 8.09399 16.5703 9.14941L18.1406 9.71484L16.5703 10.2812C13.6419 11.3367 11.3357 13.6428 10.2803 16.5713L9.71387 18.1406L9.14941 16.5713C8.09403 13.643 5.78764 11.3367 2.85938 10.2812H2.8584L1.28711 9.71484L2.8584 9.14941H2.85938C5.78762 8.09392 8.09404 5.78768 9.14941 2.85938L9.71387 1.28906L10.2803 2.85938Z",
    fill: "#E1F4D3",
    stroke: "#315E45",
    strokeWidth: 1.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/gemini.fcf8c58fd16413a7346cd131201b5e33.svg";
export { ForwardRef as ReactComponent };